<template>
    <div class="shareBar" :class="{'shareBarPC':$store.state.innerWidth>768}">
        <h4 class="SemiBold">{{$t('message.Share with')}}</h4>
        <div class="shareIcon">
                <social-sharing v-bind:url="url"
                              title="talent.gov.hk"
                              description="Discover occupations, courses, and job opportunities here!"
                              quote=""
                              hashtags=""
                              twitter-user=""
                              inline-template>
                      <div>
                          <network network="facebook">
                            <a href="javascript:;" style="color: inherit">
                            <img  src="../images/fb.png" />
                            </a>
                          </network>
                          <network network="linkedin">
                            <a href="javascript:;" style="color: inherit">
                            <img  src="../images/in.png" />
                            </a>
                          </network>
                          <network network="twitter">
                            <a href="javascript:;" style="color: inherit">
                            <img src="../images/twitter.png" />
                            </a>
                          </network>
                      </div>
        </social-sharing>
                          <span >
                            <a href="javascript:;" style="color: inherit">
                            <img src="../images/link.png" @click="copy" />
                            </a>
                          </span>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { EventBus } from "@/javascripts/eventBus.js";

import SocialSharing from 'vue-social-sharing'

Vue.use(SocialSharing);
export default {
    data() {
        return {
          url:''
        }
    },
    props: [
        "jobPostingId",
    ],
    methods: {
      copy:function(){
        var text = window.location.href;
        if(this.jobPostingId&&text.indexOf('findAnOpportunity')){
          var reg = new RegExp('findAnOpportunity', 'g');
          var job = 'jobDetail'+'/'+this.jobPostingId
          text = text.replace(reg,job);
        }
        var input = document.createElement('input');
        input.setAttribute('readonly', 'readonly'); // 防止手机上弹出软键盘
        input.setAttribute('value', text);
        document.body.appendChild(input);
        // input.setSelectionRange(0, 9999);
        input.select();
        var res = document.execCommand('copy');
        document.body.removeChild(input);
        EventBus.$emit('success', { title: this.$i18n.t("message.Copied link to clipboard") })
        // return res;
      },
      resetUrl:function(){
        var rnd = Date.now()
        var text = window.location.href+'&rnd=202101151044';
        if(this.jobPostingId&&text.indexOf('findAnOpportunity')){
          var reg = new RegExp('findAnOpportunity', 'g');
          var job = 'jobDetail'+'/'+this.jobPostingId
          text = text.replace(reg,job);
        }
        this.url = text;
      }
    },
  computed:{
    href(){
      return window.location.href;
    },
    language(){
      return this.$store.state.language;
    },
  },
  watch:{
    href (news,old) {
      this.resetUrl();
    },
    jobPostingId(n,o){
      this.resetUrl();
    },
    language(n,o){
      this.resetUrl();
    }
  },
    mounted() {
      this.$store.state.mate.url = window.location.href;
      this.resetUrl();
    }
}
</script>